export enum StorageTypeKey {
  ACCESS_TOKEN = 'access-token',
  REFRESH_TOKEN = 'refresh-token',
  CLIENT_GUID = 'client-guid',
  FIREBASE_TOKEN = 'firebase-token',
}
